import { useTranslation } from '@silospot/i18n/react';
import { BookOpen, type LucideIcon, Mail, MessageCircleQuestion } from 'lucide-react';
import type { ReactElement } from 'react';
import { Badge, Card, PageHeader } from '../../components/cld';

function Tile({
  icon: Icon,
  title,
  desc,
}: {
  icon: LucideIcon;
  title: string;
  desc: string;
}): ReactElement {
  return (
    <Card hover className="flex items-start gap-3">
      <span className="grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-accent-bg text-primary">
        <Icon className="h-5 w-5" />
      </span>
      <div>
        <div className="text-[14px] font-semibold text-text">{title}</div>
        <p className="mt-0.5 text-[12.5px] text-text-2">{desc}</p>
      </div>
    </Card>
  );
}

export function SupportPage(): ReactElement {
  const { t } = useTranslation('pages');
  return (
    <div>
      <PageHeader title={t('support.title')} sub={t('support.intro')} />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <Tile icon={BookOpen} title={t('support.docs')} desc={t('support.docsDesc')} />
        <Tile icon={Mail} title={t('support.contact')} desc={t('support.contactDesc')} />
        <Tile icon={MessageCircleQuestion} title={t('support.faq')} desc={t('support.faq')} />
      </div>
      <Card className="mt-4 flex items-center justify-between">
        <span className="text-[14px] font-semibold text-text">{t('support.status')}</span>
        <Badge tone="clean" dot>
          {t('support.statusOk')}
        </Badge>
      </Card>
    </div>
  );
}
